import { hotelSetupSteps } from 'features/HotelSetup'
import ActiveDot from 'features/HotelSetup/Header/ActiveDot'
import DoneDot from 'features/HotelSetup/Header/DoneDot'
import EmptyDot from 'features/HotelSetup/Header/EmptyDot'
import PropTypes from 'prop-types'

import styles from './EditableHotelList.module.scss'

const ActiveStep = ({ name }) => (
  <div className={styles.step}>
    <p className={styles.activeStepTitle}>{name}</p>
    <ActiveDot />
  </div>
)

const EmptyStep = ({ name }) => (
  <div className={styles.step}>
    <p className={styles.stepTitle}>{name}</p>
    <EmptyDot />
  </div>
)

const DoneStep = ({ name }) => (
  <div className={styles.step}>
    <p className={styles.stepTitle}>{name}</p>
    <DoneDot />
  </div>
)

const StepsStatus = ({ step, isSetupCompleted }) => {
  if (!step) return null

  return (
    <div className={styles.timeline}>
      {isSetupCompleted && (
        <>
          <DoneStep name="Addendum" />
          <DoneStep name="Hotel staff" />
          <DoneStep name="Legal info" />
        </>
      )}
      {!isSetupCompleted && step === hotelSetupSteps.Addendum && (
        <>
          <ActiveStep name="Addendum" />
          <EmptyStep name="Hotel staff" />
          <EmptyStep name="Legal info" />
        </>
      )}
      {!isSetupCompleted && step === hotelSetupSteps.HotelStaff && (
        <>
          <DoneStep name="Addendum" />
          <ActiveStep name="Hotel staff" />
          <EmptyStep name="Legal info" />
        </>
      )}
      {!isSetupCompleted && step === hotelSetupSteps.LegalInformation && (
        <>
          <DoneStep name="Addendum" />
          <DoneStep name="Hotel staff" />
          <ActiveStep name="Legal info" />
        </>
      )}
    </div>
  )
}

StepsStatus.propTypes = {
  step: PropTypes.oneOf(['Addendum', 'HotelStaff', 'LegalInformation']).isRequired
}

export default StepsStatus
